<template>
  <div class="autocomplete">
    <input
        :disabled="disabled"
        :class="{
              'select_full_width': fullWidth,
              'select': !fullWidth,
              'validation-filed-border':
              keyInput && errors[keyInput] && errors[keyInput].message,
            }"
        type="text"
        :placeholder="$i18nApi.t('checkout5.'+ keyInput)"
        :id="keyInput"
        @input="onChange"
        v-model="search"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
    />
    <ul
        id="autocomplete-results"
        v-show="isOpen"
        class="autocomplete-results"
    >
      <li
          class="loading"
          v-if="isLoading"
      >
        Loading results...
      </li>
      <li
          v-else
          v-for="(result, i) in results"
          :key="i"
          @click="setResult(result)"
          class="autocomplete-result"
          :class="{ 'is-active': i === arrowCounter }"
      >
        {{ result }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Autocomplete',
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    form: {
      type: Object,
      required: false,
      default: () => {},
    },
    errors: {
      type: Object,
      required: false,
      default: () => {},
    },
    keyInput: {
      type: String,
      required: true,
      default: '',
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      results: [],
      search: this.value != '' ? this.value : '',
      arrowCounter: -1,
    };
  },
  watch: {
    items: function (value, oldValue) {
      if (value.length !== oldValue.length) {
        this.results = value;
      }
      if (this.items.length == 0) {
        this.isOpen = false
      }
    },
    isLoading: function () {
      if (!this.isLoading) {
        this.filterResults();
      }
    },
    search: function () {
      if (this.items.length > 0) {
        this.isOpen = true
      }
    },
    value: function () {
      if (this.value == '') {
        this.items = [];
        this.search = '';
      }

      if (this.value != '') {
        this.setResult(this.value);
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    setResult(result) {
      this.search = result;

      this.$emit('input', this.search);
    },
    filterResults() {
      if (this.search) {
        this.results = this.items.filter((item) => {
            return item.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
        });
      } else {
        this.results = this.items
      }
    },
    onChange() {
      this.$emit('input', this.search);
      this.isOpen = false;
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
        this.arrowCounter = -1;
      } else {
        if (this.items.length > 1) {
          this.isOpen = true;
        } else {


          if (this.items.filter((item) => {
            return this.search !== '' ? item.toLowerCase().indexOf(this.search.toLowerCase()) > -1 : false;
          }).length === 1) {
            this.isOpen = false;
          } else {
            this.isOpen = true;
          }
        }
      }
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      this.search = this.results[this.arrowCounter];
      this.isOpen = false;
      this.arrowCounter = -1;
    },
  },
};
</script>

<style scoped>
.autocomplete {
  position: relative;
}

.autocomplete-results {
  padding: 0;
  margin: 0;
  border: 1px solid #eeeeee;
  height: 120px;
  overflow: auto;
  position: absolute;
  width: 100%;
  z-index: 1;
  background: #fff;
  box-shadow: 0px 4px 20px -2px rgba(0, 0, 0, 0.3);
  border-radius: 7px;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 4px 2px;
  cursor: pointer;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: #4AAE9B;
  color: white;
}
</style>
